import React from 'react';
import PropTypes from 'prop-types';

const DeniedMethodAdvice = ({ t, className }) => (
  <div className={className}>
    <div>
      <span>{t('denied_advice')}</span>
    </div>
  </div>
);

DeniedMethodAdvice.propTypes = {
  className: PropTypes.string,
  t: PropTypes.func,
};

DeniedMethodAdvice.defaultProps = {
  className: '',
  t: (t) => t,
};

export default DeniedMethodAdvice;
